import React, { useEffect } from "react";
import {
  ChallengerMain,
  ChallengerConf,
  ChallengerData,
  DefaultLocalizationMap
} from "@aishield/challenger";

// The Challenger Component to include in each form where Challenger is necessary
//    Place it just before the "Submit" button or the element that the EndUser should
//    be utilizing
function Challenger (props: {
  cpid: string;
  main: ChallengerMain;
  isReadyCallback?: (isReady: boolean) => void;
  refreshOnDerender?: boolean;
}) {
  const main = props.main;
  const cpid = props.cpid;
  const isReadyCallback = props.isReadyCallback;
  const refreshOnDerender = props.refreshOnDerender !== undefined ? props.refreshOnDerender : false;

  // starts ChallengerRunner once component is loaded
  //  returns function to stop the compontent once unmounted
  useEffect(() => {
    main.render(cpid, cpid, isReadyCallback);
    return () => {
      main.derender(cpid, refreshOnDerender);
    };
  }, []);

  return <div id={"challenger_" + cpid} className='challenger' aria-label=' '/>;
};

export default Challenger;
export { ChallengerMain, ChallengerConf, ChallengerData, DefaultLocalizationMap };
